<template>
    <nuxt-layout :name="layout">
        <div class="errorContainer text-center full-width d-flex flex-column align-center justify-center">
            <div class="d-flex pb-16">
                <div class="square">
                    <span class="text-h2 font-weight-bold text-white"> {{ error.statusCode }} </span>
                </div>
            </div>
            <div class="d-flex flex-column" style="z-index: 1">
                <template v-if="error.statusCode === 404">
                    <div class="text-h4 mb-5 font-weight-regular">
                        {{ $t('error_message.page_not_found') }}
                    </div>
                    <v-btn color="primary" @click="$router.go(-1)">{{ $t('go_back') }}</v-btn>
                </template>
                <template v-else>
                    <div class="text-h4 font-weight-regular">
                        {{ error.message }}
                    </div>
                    <div v-if="error.statusCode === 500" class="text-subtitle-1 text-grey-lighten-1 mb-5">
                        {{ error.note || $t('warning_message.service_unavailable_note') }}
                    </div>
                    <div v-else class="text-subtitle-1 text-grey-lighten-1 mb-5">
                        {{ $t('error_message.something_went_wrong') }}
                    </div>
                </template>
            </div>
        </div>
    </nuxt-layout>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class ErrorLayout extends Vue {
        @Prop() error

        get layout() {
            return 'centered'
        }
    }

    export default ErrorLayout
</script>

<style lang="scss" scoped>
    .errorContainer {
        width: 100%;
    }

    .square {
        width: 160px;
        height: 160px;
        border-radius: 1.2rem;
        background: #ef5350;
        box-shadow:
            #ef5350 0 0 3px 10px,
            #e57373 0 0 6px 20px,
            #ef9a9a 0 0 9px 30px,
            #ffcdd2 0 0 12px 40px;
        transform: rotateZ(-21deg);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
</style>
